import { request, useMutation } from '@applyboard/ui-utils';
import { z } from 'zod';

export interface StudentRegistrationRequestForm {
  birthDate: string;
  citizenship: string;
  countryOfInterest: string[];
  servicesOfInterest: string[];
  didDeclaration: boolean;
  email: string;
  givenName: string;
  middleName: string;
  familyName: string;
  gender: string;
  phone: string;
  referralSource: string;
  passportNumber: string;
  passportExpiry: string;
  passport?: File;
  agentId: number;
  citizenshipCountryCode: string;
  customLeadSource?: string;
}

const rawCreateStudentResponseSchema = z.object({
  message: z.string().nullish(),
  studentUserId: z.string().nullish(),
});

export function useStudentRegistrationRequest() {
  const { mutate, isLoading, isSuccess, isError } = useMutation(async (requestBody: FormData) => {
    return request('/api/rpj-bff/student-intake', {
      method: 'POST',
      body: requestBody,
      schema: rawCreateStudentResponseSchema,
    });
  });
  const createStudentRequest = (
    formData: StudentRegistrationRequestForm,
    onSuccess: () => void,
    onError: (error: unknown) => void,
  ) => {
    const requestBody = new FormData();
    const data = {
      ...formData,
      servicesOfInterest: formData.servicesOfInterest.map(service => parseInt(service)),
    };
    requestBody.append('studentInfo', JSON.stringify(data));
    if (formData.passport) {
      requestBody.append('passport', formData.passport);
    }
    mutate(requestBody, {
      onSuccess,
      onError,
    });
  };
  return {
    createStudentRequest,
    isCreatingStudentRequest: isLoading,
    isCreateStudentSuccess: isSuccess,
    isCreateStudentError: isError,
  };
}
